function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}export var loggedExerciseDefaults = {
  id: 0,
  cal: 0,
  exercise: 0,
  minutes: 0,
  title: "",
  tracker: 0 };LoggedExerciseModel.$inject = ["$modelFactory", "ApiHttp"];


export function LoggedExerciseModel(
$modelFactory,
ApiHttp)
{
  "ngInject";var

  LoggedExerciseModel = /*#__PURE__*/function (_$modelFactory) {_inherits(LoggedExerciseModel, _$modelFactory);function LoggedExerciseModel() {_classCallCheck(this, LoggedExerciseModel);return _possibleConstructorReturn(this, (LoggedExerciseModel.__proto__ || Object.getPrototypeOf(LoggedExerciseModel)).apply(this, arguments));}return LoggedExerciseModel;}($modelFactory(ApiHttp.loggedExercise, {
    defaults: loggedExerciseDefaults,

    map: {},

    actions: {
      create: {
        method: 'POST',
        afterRequest: function afterRequest(data) {
          console.warn('logged exercise created');
        } } } }));




  LoggedExerciseModel.List.Model = LoggedExerciseModel;

  return LoggedExerciseModel;
}